// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useLedgerEnd } from '../ledger/useLedgerEnd';

const useHoldings: () => UseQueryResult<TemplateContract<Holding>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { operator } = useParties();
  return useQuery({
    queryKey: ['queryHoldings', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryHoldings(offset!, operator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useHoldings;
